<p-dialog
        (onHide)="onHide($event)"
        [(visible)]="visible"
        [breakpoints]="{ '960px': '90vw', '640px': '95vw' }"
        [closable]="false"
        [modal]="true"
        [style]="{ width: width(), height: height() }">

    <ng-template #header>
        <div class="flex flex-row justify-between items-center w-full">
            <div class="header-title-dialog">{{ headerTitle() }}</div>
            @if (closable()) {
                <p-button (onClick)="onCloseClick()"
                    (keydown.enter)="$event.preventDefault(); onCloseClick()"
                    (keydown.space)="$event.preventDefault(); onCloseClick()" ariaLabel="Fechar" pTooltip="Fechar"
                          styleClass="btn-icon"
                          tooltipPosition="bottom">
                    <app-icon-bold-close-square color="rgba(73, 73, 73, 1)"/>
                </p-button>
            }
        </div>
    </ng-template>
    <ng-content></ng-content>
    <ng-template #footer>
        <ng-content select="[footer]"></ng-content>
    </ng-template>
</p-dialog>
